// Constante de valores para usar MigrationStatus en templates y lógica.
// El tipo MigrationStatus viene del backend (string union) y se infiere de este objeto.

/**
 * Objeto de constantes para usar MigrationStatus como valor en templates y código.
 * Equivalente a un enum, compatible con el string union type del backend.
 */
export const MigrationStatus = {
  PersonPending: 'PersonPending',
  UserPending: 'UserPending',
  Migrated: 'Migrated',
  IdpUserMissing: 'IdpUserMissing',
  Error: 'Error',
  /** @deprecated Usar PersonPending. El backend usa PersonPending, no MemberPending. */
  MemberPending: 'PersonPending',
} as const;

export type MigrationStatus = typeof MigrationStatus[keyof typeof MigrationStatus];
